import { Droplist } from "../droplist"
import EditField from "../editfield"
import { toHex } from "../../../common/utility"
import { useState } from "react"
import { useTranslation } from "../../../i18n/useTranslation"
import { breakpointExpressionRegToName } from "../../../common/breakpoint"

interface ExpressionControlProps {
  expr: BreakpointExpression;
  setExpr: (expr: BreakpointExpression) => void;
  disabled?: boolean;
}

const ExpressionControl = (props: ExpressionControlProps) => {
  //  const [triggerUpdate, setTriggerUpdate] = useState(false)
  const { t } = useTranslation()
  const [bpAddress, setBpAddress] = useState(toHex(props.expr.address))
  const [bpValue, setBpValue] = useState(props.expr.value.toString(props.expr.register === "@" ? 10 : 16).toUpperCase())

  const handleAddressChange = (value: string) => {
    value = value.replace(/[^0-9a-f]/gi, "").slice(0, 4).toUpperCase()
    setBpAddress(value)
    props.setExpr({ ...props.expr, address: parseInt(value || "-1", 16) })
  }

  const handleRegisterChange = (value: RegisterValues) => {
    //    setTriggerUpdate(!triggerUpdate)
    props.setExpr({ ...props.expr, register: value })
  }

  const handleOperatorChange = (value: OperatorValues) => {
    props.setExpr({ ...props.expr, operator: value })
  }

  const handleValueChange = (value: string) => {
    if (props.expr.register === "@") {
      value = value.replace(/[^0-9]/gi, "").toUpperCase()
      setBpValue(value)
      props.setExpr({ ...props.expr, value: parseInt(value || "-1") })
    } else {
      const maxlen = props.expr.register === "C" ? 4 : 2
      value = value.replace(/[^0-9a-f]/gi, "").slice(0, maxlen).toUpperCase()
      setBpValue(value)
      props.setExpr({ ...props.expr, value: parseInt(value || "-1", 16) })
    }
  }

  const spaces = "\u00A0\u00A0\u00A0\u00A0\u00A0"
  const regmap: Array<RegisterValues> = ["", "$", "A", "X", "Y", "S", "P", "C", "@"]
  const registers = regmap.map((reg) => `${reg}${spaces}${breakpointExpressionRegToName(reg as RegisterValues)}`)
  const index = regmap.indexOf(props.expr.register)
  const isCycleCount = props.expr.register === "@"

  return <span>
    <Droplist
      disabled={props.disabled}
      value={registers[index]}
      values={registers}
      setValue={(v: string) =>
        handleRegisterChange(v.substring(0, 1).replace(/\s/g, "") as RegisterValues)}
      narrow={true} />
    {
      (props.expr.register === "$") &&
      <EditField
        disabled={props.disabled || index === 0}
        value={bpAddress}
        setValue={handleAddressChange}
        isHex={true}
        placeholder={t("debug.any")}
        width="3em" />
    }
    <Droplist
      monospace={true}
      disabled={props.disabled || index === 0}
      value={props.expr.operator}
      values={["==", "!=", ">", ">=", "<", "<="]}
      setValue={(v: string) => handleOperatorChange(v as OperatorValues)} />
    { (!isCycleCount) && <span className="dialog-title" style={{ padding: 0 }}>$</span>}
    <EditField
      disabled={props.disabled || index === 0}
      value={bpValue}
      setValue={handleValueChange}
      isHex={true}
      placeholder={isCycleCount ? "100000" : "FF"}
      width={isCycleCount ? "9em" : "3em"} />
  </span>
}

export default ExpressionControl
